/*cleaned by Claude AI = 2026-04-02*/

var bookedDates = [];


document.addEventListener("DOMContentLoaded", async () => {
  // make this a theme setting
  const ICS_URL = ICS_URL_2;
  // "{{settings.soma_calendar_link}}";
    // "https://downloads.bookinglayer.io/product_calendar/42ffb462-87b6-4005-94bb-fdbbdb4b156a.ics?signature=86101c1a21f7d64587de6b4e19837587cbe8d8e5dd8d1dcaf8466311ddb37183";

  // --- Fetch availability ---
  try {
    bookedDates = await fetchIcsDateRanges(ICS_URL);
  } catch (err) {
    console.error(err);
    document.getElementById("calendar-error").style.display = "block";
    document.getElementById("soma-availability-calendar").style.display = "none";
    return;
  }

  // --- State ---
  let currentDate = new Date();

  const MONTH_NAMES = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Calendars: [element id, month/year label id, month offset]
  const CALENDARS = [
    ["calendar",   "monthYear",   0],
    ["calendar-2", "monthYear-2", 1],
    ["calendar-3", "monthYear-3", 2],
  ];

  // --- Date classification ---

  /**
   * Returns "checkin", "checkout", "blocked", or null for a given date string.
   * A date that is both a check-in and check-out (back-to-back bookings) is "blocked".
   */
  function getDateType(dateStr) {
    const date = new Date(dateStr);
    let isCheckIn = false;
    let isCheckOut = false;
    let isBlocked = false;

    for (const entry of bookedDates) {
      if (entry.includes(":")) {
        const [startStr, endStr] = entry.split(":");
        const start = new Date(startStr);
        const end = new Date(endStr);
        if (date.getTime() === start.getTime()) isCheckIn = true;
        if (date.getTime() === end.getTime()) isCheckOut = true;
        if (date > start && date < end) isBlocked = true;
      } else if (entry === dateStr) {
        isBlocked = true;
      }
    }

    if (isCheckIn && isCheckOut) return "blocked";
    if (isCheckIn) return "checkin";
    if (isCheckOut) return "checkout";
    if (isBlocked) return "blocked";
    return null;
  }

  // --- Rendering ---

  function renderCalendar(calendarId, labelId, monthOffset) {
    const calendarEl = document.getElementById(calendarId);
    // Build cells off-DOM and swap them in once, rather than appending one at a time
    const fragment = document.createDocumentFragment();

    const base = new Date(currentDate.getFullYear(), currentDate.getMonth() + monthOffset, 1);
    const year = base.getFullYear();
    const month = base.getMonth();
    const firstDay = base.getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    document.getElementById(labelId).textContent = `${MONTH_NAMES[month]} ${year}`;

    // Day-of-week headers
    DAY_NAMES.forEach((day) => {
      const el = document.createElement("div");
      el.className = "day-name";
      el.textContent = day;
      fragment.appendChild(el);
    });

    // Empty leading cells
    for (let i = 0; i < firstDay; i++) {
      const el = document.createElement("div");
      el.className = "empty-day";
      fragment.appendChild(el);
    }

    // Date cells
    for (let date = 1; date <= daysInMonth; date++) {
      const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(date).padStart(2, "0")}`;
      const thisDate = new Date(year, month, date);

      const el = document.createElement("div");
      el.className = "date";
      el.textContent = date;

      if (thisDate.getTime() === today.getTime()) el.id = "today";

      if (thisDate < today) {
        el.classList.add("past");
      } else {
        const type = getDateType(dateStr);
        if (type) el.classList.add(type);
      }

      fragment.appendChild(el);
    }

    calendarEl.replaceChildren(fragment);
  }

  function renderAll() {
    CALENDARS.forEach(([calId, labelId, offset]) => renderCalendar(calId, labelId, offset));
  }

  // --- Slide animation ---

  const calendarTrack = document.getElementById("calendarTrack");

  function slide(direction, callback) {
    const width = calendarTrack.children[0].offsetWidth + 10;
    const translateX = direction === "next" ? `-${width}px` : `${width}px`;

    calendarTrack.style.transition = "transform 0.4s ease";
    calendarTrack.style.transform = `translateX(${translateX})`;

    setTimeout(() => {
      calendarTrack.style.transition = "none";
      calendarTrack.style.transform = "translateX(0)";
      callback();
    }, 400);
  }

  // --- Navigation ---

  document.getElementById("prevMonth").addEventListener("click", () => {
    slide("prev", () => {
      currentDate.setMonth(currentDate.getMonth() - 1);
      renderAll();
    });
  });

  document.getElementById("nextMonth").addEventListener("click", () => {
    slide("next", () => {
      currentDate.setMonth(currentDate.getMonth() + 1);
      renderAll();
    });
  });

  // Initial render
  renderAll();
});

// ---------------------------------------------------------------------------
// ICS Fetching & Parsing
// ---------------------------------------------------------------------------

/**
 * Fetches an ICS feed and extracts VEVENT date ranges.
 * @param {string} icsUrl - Publicly accessible ICS URL (must allow CORS)
 * @returns {Promise<string[]>} Array of "YYYY-MM-DD:YYYY-MM-DD" strings
 */
async function fetchIcsDateRanges(icsUrl) {
  let parsed;
  try {
    parsed = new URL(icsUrl);
  } catch {
    throw new Error("Invalid ICS URL provided.");
  }

  if (!["https:", "http:"].includes(parsed.protocol)) {
    throw new Error("ICS URL must use HTTP or HTTPS.");
  }

  const response = await fetch(icsUrl, { mode: "cors" });
  if (!response.ok) throw new Error(`Failed to fetch ICS: HTTP ${response.status}`);

  return parseIcsDates(await response.text());
}

/**
 * Parses raw ICS text and returns an array of "YYYY-MM-DD:YYYY-MM-DD" date range strings.
 * @param {string} icsText
 * @returns {string[]}
 */
function parseIcsDates(icsText) {
  const lines = icsText.replace(/\r\n|\r/g, "\n").split("\n");
  const events = [];

  let inEvent = false;
  let dtStart = null;
  let dtEnd = null;

  const extractDate = (value) => {
    const clean = value.split("T")[0].replace(/\D/g, "");
    if (clean.length < 8) return null;
    const dateStr = `${clean.slice(0, 4)}-${clean.slice(4, 6)}-${clean.slice(6, 8)}`;
    return isNaN(Date.parse(dateStr)) ? null : dateStr;
  };

  for (const rawLine of lines) {
    const line = rawLine.trim();

    if (line === "BEGIN:VEVENT") {
      inEvent = true;
      dtStart = null;
      dtEnd = null;
      continue;
    }

    if (line === "END:VEVENT") {
      inEvent = false;
      if (dtStart && dtEnd) events.push(`${dtStart}:${dtEnd}`);
      continue;
    }

    if (!inEvent) continue;

    const colonIdx = line.indexOf(":");
    if (colonIdx === -1) continue;

    // Handle keys like "DTSTART;TZID=America/New_York"
    const key = line.slice(0, colonIdx).split(";")[0].toUpperCase();
    const val = line.slice(colonIdx + 1);

    if (key === "DTSTART") dtStart = extractDate(val);
    else if (key === "DTEND") dtEnd = extractDate(val);
  }

  return events;
}